import dayjs from 'dayjs'

export function formatTime (timestamp) {
  if (!timestamp) return null
  return dayjs(timestamp).format('YYYY-MM-DD @ HH:mm:ss')
}

export function formatTimeMs (timestamp) {
  if (!timestamp) return null
  return dayjs(timestamp).format('YYYY-MM-DD @ HH:mm:ss.SSS')
}
